"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrandAndWebsiteFromOrigin = void 0;
var getBrandAndWebsiteFromOrigin = function (_a) {
    var _b;
    var url = _a.url, host = _a.host;
    var website = '';
    var brand = '';
    var appNameConf = (_b = process === null || process === void 0 ? void 0 : process.env) === null || _b === void 0 ? void 0 : _b['NEXT_PUBLIC_BRAND_NAME'];
    try {
        if (url) {
            var hostname = new URL(url).hostname;
            website = hostname;
        }
        else if (host)
            website = host;
        var parts = website.split('.');
        brand = appNameConf
            ? appNameConf
            : parts.length > 2
                ? parts.slice(1, -1).join('.')
                : parts[0];
    }
    catch (error) { }
    return {
        website: website,
        brand: brand,
    };
};
exports.getBrandAndWebsiteFromOrigin = getBrandAndWebsiteFromOrigin;
